/* ========================================
   HERO CHAINZOKU + GLOBAL PARALLAX
   Interactive JS: parallax mouse, confetti,
   pastel mountains parallax, global scroll parallax
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  initHeroMouseParallax();
  initHeroConfetti();
  initHeroScrollFade();
  initMountainParallax();
  initGlobalParallax();
});

/* ---------- Mouse parallax for hero layers ---------- */
function initHeroMouseParallax() {
  const hero = document.querySelector('.hero-chainzoku');
  if (!hero) return;

  const shapes = hero.querySelectorAll('.hero-shape');
  const logo = hero.querySelector('.hero-chainzoku__logo-wrap');
  const mountains = hero.querySelectorAll('.hero-mountains__layer');

  // Skip on touch devices
  if (window.matchMedia('(pointer: coarse)').matches) return;

  hero.addEventListener('mousemove', (e) => {
    const { clientX, clientY } = e;
    const { innerWidth, innerHeight } = window;

    const xPercent = (clientX / innerWidth - 0.5) * 2;
    const yPercent = (clientY / innerHeight - 0.5) * 2;

    shapes.forEach((shape, index) => {
      const depth = (index + 1) * 15;
      const moveX = xPercent * depth;
      const moveY = yPercent * depth;
      shape.style.transform = `translate(${moveX}px, ${moveY}px)`;
    });

    mountains.forEach((mtn, index) => {
      const depth = (index + 1) * 4;
      const moveX = xPercent * depth;
      const moveY = yPercent * depth * 0.5;
      mtn.style.transform = `translate(${moveX}px, ${moveY}px)`;
    });

    if (logo) {
      const moveX = xPercent * 8;
      const moveY = yPercent * 8;
      logo.style.transform = `translate(${moveX}px, ${moveY}px)`;
    }
  });
}

/* ---------- Scroll parallax for pastel mountains ---------- */
function initMountainParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const hero = document.querySelector('.hero-chainzoku');
  if (!hero) return;

  gsap.registerPlugin(ScrollTrigger);

  const back = hero.querySelector('[data-mountain="back"]');
  const mid = hero.querySelector('[data-mountain="mid"]');
  const front = hero.querySelector('[data-mountain="front"]');

  if (back) {
    gsap.to(back, {
      y: '-30%',
      x: '-8%',
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      }
    });
  }

  if (mid) {
    gsap.to(mid, {
      y: '-55%',
      x: '12%',
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      }
    });
  }

  if (front) {
    gsap.to(front, {
      y: '-85%',
      x: '-6%',
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      }
    });
  }
}

/* ---------- Hero Falling Particles Canvas ---------- */
function initHeroConfetti() {
  const hero = document.querySelector('.hero-chainzoku');
  if (!hero) return;

  // Create a dedicated canvas for hero falling particles
  const canvas = document.createElement('canvas');
  canvas.id = 'hero-falling-particles';
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;z-index:5;pointer-events:none;overflow:hidden;';
  hero.insertBefore(canvas, hero.firstChild);

  const ctx = canvas.getContext('2d');
  let particles = [];
  const isTouch = window.matchMedia('(pointer: coarse)').matches;

  function resize() {
    const rect = hero.getBoundingClientRect();
    canvas.width = rect.width;
    canvas.height = rect.height;
  }
  resize();
  window.addEventListener('resize', resize);

  const palette = [
    'rgba(255, 214, 186, 0.85)',
    'rgba(181, 234, 215, 0.85)',
    'rgba(199, 206, 234, 0.85)',
    'rgba(255, 170, 165, 0.85)',
    'rgba(255, 209, 220, 0.85)',
    'rgba(162, 210, 255, 0.85)',
    'rgba(255, 245, 186, 0.85)',
    'rgba(255, 223, 211, 0.85)',
  ];

  class FallingParticle {
    constructor() {
      this.reset(true);
    }

    reset(randomY = false) {
      this.x = Math.random() * canvas.width;
      this.y = randomY ? Math.random() * canvas.height : -20;
      this.size = Math.random() * 8 + 3;
      this.speedY = Math.random() * 2.5 + 1.2;
      this.speedX = (Math.random() - 0.5) * 1.5;
      this.color = palette[Math.floor(Math.random() * palette.length)];
      this.rotation = Math.random() * Math.PI * 2;
      this.rotationSpeed = (Math.random() - 0.5) * 0.04;
      this.sway = Math.random() * Math.PI * 2;
      this.swaySpeed = Math.random() * 0.025 + 0.01;
      this.opacity = Math.random() * 0.4 + 0.6;
    }

    update() {
      this.y += this.speedY;
      this.x += this.speedX + Math.sin(this.sway) * 0.4;
      this.sway += this.swaySpeed;
      this.rotation += this.rotationSpeed;

      if (this.y > canvas.height + 20) {
        this.reset();
      }
    }

    draw() {
      ctx.save();
      ctx.globalAlpha = this.opacity;
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rotation);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      // Draw soft rounded rectangle
      const r = this.size;
      ctx.moveTo(-r, -r * 0.5);
      ctx.lineTo(r, -r * 0.5);
      ctx.quadraticCurveTo(r * 1.3, 0, r, r * 0.5);
      ctx.lineTo(-r, r * 0.5);
      ctx.quadraticCurveTo(-r * 1.3, 0, -r, -r * 0.5);
      ctx.fill();
      ctx.restore();
    }
  }

  const count = isTouch ? 60 : 180;
  for (let i = 0; i < count; i++) {
    particles.push(new FallingParticle());
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(p => { p.update(); p.draw(); });
    requestAnimationFrame(animate);
  }
  animate();
}

/* ---------- Scroll fade for hero text ---------- */
function initHeroScrollFade() {
  const hero = document.querySelector('.hero-chainzoku');
  const content = hero?.querySelector('.hero-chainzoku__content');
  const logo = hero?.querySelector('.hero-chainzoku__logo-wrap');
  if (!hero) return;

  const onScroll = () => {
    const rect = hero.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, -rect.top / (rect.height * 0.5)));
    if (content) {
      content.style.opacity = 1 - progress;
      content.style.transform = `translateY(${progress * 40}px)`;
    }
    if (logo) {
      logo.style.opacity = 1 - progress * 0.6;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ---------- Global Parallax for other homepage sections ---------- */
function initGlobalParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // Parallax for section titles on homepage
  const sections = document.querySelectorAll('.section-category-nav, .section-collection-list, .section-multicolumn, .section-image-with-text, .section-accordion, .section-rich-text');

  sections.forEach((section) => {
    const title = section.querySelector('h2, .section-title');
    const content = section.querySelector('.section-content, .grid, .multicolumn-list');

    if (title) {
      gsap.fromTo(title,
        { y: 40, opacity: 0.8 },
        {
          y: 0,
          opacity: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top 85%',
            end: 'top 50%',
            scrub: true,
          }
        }
      );
    }

    if (content) {
      gsap.fromTo(content,
        { y: 60 },
        {
          y: 0,
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            start: 'top 90%',
            end: 'top 40%',
            scrub: true,
          }
        }
      );
    }
  });

  // Extra parallax for images inside image-with-text sections
  const parallaxImages = document.querySelectorAll('.image-with-text__image img, .collection-list__image img, .multicolumn-card__image img');
  parallaxImages.forEach((img) => {
    gsap.fromTo(img,
      { y: '-8%', scale: 1.08 },
      {
        y: '8%',
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: img.closest('section, .grid__item, .multicolumn-card'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        }
      }
    );
  });
}
